var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableRow",
    {
      staticClass: "automation-listing__row",
      nativeOn: {
        click: function($event) {
          return _vm.handleClickRow($event)
        }
      }
    },
    [
      _vm._l(_vm.columns, function(column) {
        return [
          column.code === "name"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: column.maxWidth } },
                [
                  _c("div", { staticClass: "automation-listing__cell--name" }, [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.automation.name) +
                            "\n                "
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "date"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: {
                    fixed: column.fixed,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.formattedDate(_vm.automation.date)) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "status"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "automation-listing__cell--status",
                  attrs: {
                    alignContent: column.alignContent,
                    fixed: column.fixed,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [
                  _c(
                    "CompassTooltip",
                    {
                      attrs: {
                        disabled: !_vm.isDisabledAutomationTooltip,
                        content: _vm.translations.tooltipSwitchDisabled,
                        arrow: false
                      }
                    },
                    [
                      _c("CompassSwitch", {
                        attrs: {
                          value: _vm.automation.status,
                          disabled: _vm.isDisabledAutomation
                        },
                        on: { click: _vm.handleSwitchAutomation }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "actions"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "automation-listing__cell--actions",
                  attrs: {
                    fixed: column.fixed,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [
                  _c("AutomationListingTableActions", {
                    attrs: { automation: _vm.automation }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }